import { IInputProps, ObjectUtils } from 'modules';
import { isEqual } from 'modules';
import React, { FC } from 'react';
import Select from 'react-select';
import { SelectComponentsProps } from 'react-select/src/Select';
import { getReactSelectStyles } from '../../../utils/reactSelectStyles';

const SelectElement = Select as any;
interface IAsyncDataConfig {
  pathLabel: string;
  pathValue: string;
  response: any;
}

interface IInputSelect extends IInputProps {
  options?: any;
  isClearable?: boolean;
  asyncData?: IAsyncDataConfig;
  isMulti?: boolean;
  components?: any;
  filterOption?: any;
}

export const InputSelect: FC<IInputSelect> = (props) => {
  const {
    asyncData,
    // Filter out custom or conflicting props that shouldn't go to Select or its children
    isDisabled,
    isMutilLocale,
    locales,
    getValue: customGetValue,
    error,
    description,
    label,
    onChangeCallback,
    onChangeEvent,
    onTouched,
    isRequired,
    isReadOnly,
    tail,
    trailing,
    limitSize,
    limitWidth,
    limitHeight,
    temp,
    urlExample,
    customTypeAccept,
    decimalScale,
    dateTimeFormat,
    isClear,
    showImage,
    onKeyDown,
    defaultValue,
    isMulti, // Destructured isMulti
    onChange, // Destructured onChange
    options, // Destructured options
    ...rest
  } = props;

  const generalProps: SelectComponentsProps = {
    ...rest,
    isMulti,
    closeMenuOnSelect: !isMulti,
    className: isMulti ? 'InputSelect_Multi' : 'InputSelect',
    classNamePrefix: isMulti ? 'InputSelect_Multi' : 'InputSelect',
    isSearchable: true,
    styles: getReactSelectStyles(),
    onChange: (data: any) => {
      if (isMulti) onChange((data || []).map((v: any) => v.value));
      else onChange(data?.value);
    },
    defaultValue,
    onBlur: () => setTimeout(() => onTouched && onTouched(), 500),
    isClearable: typeof isClear === 'boolean' ? isClear : true,
    isDisabled,
    autoFocus: false,
    components: props.components,
  };

  if (asyncData) {
    const { pathLabel, pathValue, response } = asyncData;
    const errorMessage = ObjectUtils.getIn(response, 'error.message');

    if (!response) return <input disabled defaultValue='Fetching options...' />;
    if (errorMessage)
      return <input disabled defaultValue={`Error: ${errorMessage}`} />;

    const options = ObjectUtils.getIn(response, 'data', [], (arr) =>
      arr.map((item: any) => ({
        label: ObjectUtils.getIn(item, pathLabel),
        value: ObjectUtils.getIn(item, pathValue, ''),
      })),
    );

    const getValue = () => {
      if (props.isMulti) {
        return (options || []).filter((v: any) =>
          props.value.includes(v.value),
        );
      }
      return props.value
        ? options.find((v: any) => isEqual(props.value, v.value))
        : '';
    };

    return (
      <SelectElement {...generalProps} options={options} value={getValue()} />
    );
  }

  const getValue = () => {
    if (props.isMulti)
      return (props.options || []).filter((v: any) =>
        props.value.includes(v.value),
      );
    return props.value
      ? props?.options?.find((v: any) => isEqual(props.value, v.value))
      : '';
  };

  return (
    <SelectElement
      {...generalProps}
      options={props.options}
      value={getValue()}
    />
  );
};

InputSelect.defaultProps = {
  isMulti: false,
};
